import { IAdditionalSettings } from "@/config/additionalSettings.config";

const greeceAdditionalSettingsConfig: IAdditionalSettings = {
  hasGoldenVisa: false,
};

export default greeceAdditionalSettingsConfig;
